import { render } from "./RequestRecover.vue?vue&type=template&id=0a47734e"
import script from "./RequestRecover.vue?vue&type=script&lang=ts"
export * from "./RequestRecover.vue?vue&type=script&lang=ts"
script.render = render

export default script